import { useSelector } from 'react-redux';
import { IDIncomeVerificationStatus, NotificationType } from '@common/entities';
import { RootState } from 'state/store';

import { useNotifications } from 'hooks/useNotifications';

const ENABLED_FOR_THESE_STATUSES = new Set([
  IDIncomeVerificationStatus.Success,
  IDIncomeVerificationStatus.Failed,
  IDIncomeVerificationStatus.ReInitiated,
]);

export const useFetchVerificationNotification = () => {
  const { isLeadProfile } = useSelector(
    (state: RootState) => state.auth ?? { isLeadProfile: false },
  );
  const { idVerification, incomeVerification } = useSelector(
    (state: RootState) => state.idIncomeVerification,
  );
  const { status: idVerificationStatus } = idVerification;
  const { status: incomeVerificationStatus } = incomeVerification;

  const { refetchNotifications: refetchIdNotification } = useNotifications({
    enabled:
      !isLeadProfile &&
      ENABLED_FOR_THESE_STATUSES.has(idVerificationStatus as IDIncomeVerificationStatus),
    type: NotificationType.PlaidIDVerification,
    refetchInterval: false,
  });
  const { refetchNotifications: refetchIncomeNotification } = useNotifications({
    enabled:
      !isLeadProfile &&
      ENABLED_FOR_THESE_STATUSES.has(incomeVerificationStatus as IDIncomeVerificationStatus),
    type: NotificationType.PlaidIncomeVerification,
    refetchInterval: false,
  });

  const fetchVerificationNotifications = async (checkId: boolean, checkIncome: boolean) => {
    if (isLeadProfile) return;

    const notificationsCheckList = [];
    if (checkId) {
      notificationsCheckList.push(refetchIdNotification());
    }
    if (checkIncome) {
      notificationsCheckList.push(refetchIncomeNotification());
    }
    await Promise.all(notificationsCheckList);
  };

  return {
    fetchVerificationNotifications,
  };
};
